import { useQuestionizerStore } from "../types/state";

export default function LoadingIndicator (){
  const label = useQuestionizerStore((state) => state.L('loading'));

  return (
    <div role="loading" aria-busy className={"loading-indicator"}>
      <span className={"font-xl text-center"}>
       {label} 
       <Spinner />
      </span>
    </div>
    );
}

function Spinner (){
  return (
    <div className={"spinner"}></div>
    );
}